import React, { useEffect } from 'react';
import { SideDrawerButtonContainer } from '../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../utils/intl';
import EmailListConfiguration from '../EmailListConfiguration';
import useProfileVisitInviteEmails from '../../../hooks/api/useProfileVisitInviteEmails';
import { AnimateLoadedContent } from '../../v2BaseComponents/Loader';

const intl = getIntl('visit-invite-email-side-drawer-content', {
    subscribe: 'Subscribe',
    unsubscribeAll: 'Unsubscribe All',
});

export type VisitInviteEmailSideDrawerContentOwnProps = {
    medicalProfileId: string;
    onClose: (force: boolean) => void;
};

export type VisitInviteEmailSideDrawerContentProps = VisitInviteEmailSideDrawerContentOwnProps;

const VisitInviteEmailSideDrawerContent: React.FC<VisitInviteEmailSideDrawerContentProps> = (props) => {
    const { isLoadingEmails, emails, isUpdatingEmails, updateEmails } = useProfileVisitInviteEmails({
        medicalProfileId: props.medicalProfileId,
        onUpdateEmails: () => props.onClose(true),
    });
    const [workingEmails, setWorkingEmails] = React.useState<string[]>([]);
    useEffect(() => {
        setWorkingEmails(emails.map((_) => _.inviteeEmail));
    }, [emails]);
    return (
        <AnimateLoadedContent isLoading={isLoadingEmails || isUpdatingEmails}>
            {() => (
                <SideDrawerButtonContainer
                    buttons={[
                        {
                            title: workingEmails.length ? intl('subscribe') : intl('unsubscribeAll'),
                            variant: 'primary',
                            onPress: () => {
                                updateEmails({
                                    emails: workingEmails,
                                });
                            },
                            isDisabled: isUpdatingEmails,
                            testID: 'submit-subscription-button',
                            icon: workingEmails.length ? 'Send' : 'XCircle',
                        },
                    ]}
                >
                    <EmailListConfiguration
                        value={workingEmails}
                        onChange={setWorkingEmails}
                        medicalProfileId={props.medicalProfileId}
                    />
                </SideDrawerButtonContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(VisitInviteEmailSideDrawerContent);
